<template>
  <div class="bg-white flex items-center h-screen w-full">
    <side-nav />
    <div class="h-full flex flex-col flex-1 self-stretch">
      <nav-bar :title="String(currentPathName) || ''" />
      <main class="flex-1 w-full p-7 overflow-y-auto">
        <router-view></router-view>
      </main>
    </div>
  </div>
</template>

<script lang="ts">
import SideNav from '@/components/dashboard/SideNav.vue';
import NavBar from '@/components/dashboard/NavBar.vue';

import { Vue, Options } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Options({
  components: {
    SideNav,
    NavBar
  }
})
export default class Dashboard extends Vue {
  public currentPathName: any = '';

  mounted() {
    this.currentPathName = this.$route.name;
  }
  @Watch('$route')
  public onRouteNameChange() {
    this.currentPathName = this.$route.name;
  }
}
</script>
